import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface NavbarProps {
  isAuthenticated: boolean;
}

const Navbar = ({ isAuthenticated }: NavbarProps) => {
  const navigate = useNavigate();

  return (
    <nav className="sticky top-0 w-full z-50 border-b bg-background/95 backdrop-blur-sm">
      <div className="container mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
        <h1 
          className="text-lg sm:text-xl md:text-2xl font-bold bg-gradient-to-r from-primary to-primary/60 bg-clip-text text-transparent cursor-pointer hover:opacity-80 transition-opacity"
          onClick={() => navigate("/")}
        >
          The Lost Strings
        </h1>
        <div className="flex gap-2 sm:gap-4 items-center">
          {isAuthenticated ? (
            <Button 
              variant="outline" 
              size="sm" 
              onClick={() => navigate("/dashboard")}
              className="text-xs sm:text-sm px-3 sm:px-4"
            >
              Dashboard
            </Button>
          ) : (
            <Button 
              variant="default" 
              size="sm" 
              onClick={() => navigate("/auth")}
              className="text-xs sm:text-sm px-3 sm:px-4"
            >
              Sign In
            </Button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
